import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdateCargoTypeActions as Actions,
  UpdateCargoTypeRequestAction as RequestAction,
} from 'store/ducks/cargoTypes';

export function* updateCargoTypeRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `cargo-types/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Tipo de carga atualizado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
